import { COLOR_SYSTEM } from "components/design/design-system";
import React from "react";
import styled, { keyframes } from "styled-components";

export type SpinnerSize = "Small" | "Medium" | "Large";

export interface SpinnerProps {
  size?: SpinnerSize;
  color?: string;
}

const getSizeValue = (size: SpinnerSize) => {
  switch (size) {
    case "Small":
      return { width: "24px", height: "24px", border: "2px" };
    case "Medium":
      return { width: "36px", height: "36px", border: "3px" };
    case "Large":
      return { width: "48px", height: "48px", border: "4px" };
    default:
      return { width: "24px", height: "24px", border: "2px" };
  }
};

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SpinnerElement = styled.div<SpinnerProps>`
  width: ${(props) => getSizeValue(props.size || "Small").width};
  height: ${(props) => getSizeValue(props.size || "Small").height};
  border-radius: 50%;
  border: ${(props) => getSizeValue(props.size || "Small").border} solid rgba(255, 255, 255, 0.3);
  border-top: ${(props) => getSizeValue(props.size || "Small").border} solid
    ${(props) => props.color || COLOR_SYSTEM.get("Skyblue")?.[400]};
  animation: ${rotate} 0.8s linear infinite;
`;

const Spinner: React.FC<SpinnerProps> = ({ size = "Small", color }) => {
  return (
    <SpinnerContainer>
      <SpinnerElement size={size} color={color} />
    </SpinnerContainer>
  );
};

export default Spinner;
